import { configureStore } from "@reduxjs/toolkit";
import emailVerificationCodeReducer from "./Common/EmailSendVerificationCodeSlice";
import emailVerifyCodeReducer from "./Common/EmailVerifyCodeSlice";
import createProfileProfessionalReducer from "./Professional/CreateProfileSlice";
import getProfileProfessionalReducer from "./Professional/GetProfileSlice";

import getServiceProfessionalReducer from "./Professional/GetServiceSlice";
import loginProfessionalReducer from "./Professional/LoginSlice";
import loginClientReducer from "./Client/LoginSlice";
import signUpClientReducer from "./Client/SignUpClientSlice";
import signUpProfessionalReducer from "./Professional/SignUpProfessionalSlice";
import emailVerificationV2ProfessionalReducer from "./Professional/EmailVerificationV2ProfessionalSlice";
import createProfileClientReducer from "./Client/CreateProfileSlice";
import emailVerificationV2Reducer from "./Client/EmailVerificationV2Slice";
import getProfileClientReducer from "./Client/GetProfileClientSlice";

import verifyLoginPhoneClientReducer from "./Client/VerifyLoginPhoneSlice";
import uploadMediaReducer from "./Common/UploadMediaSlice";
import updateProfileProfessionalReducer from "./Professional/UpdateProfileProfessionalSlice";
import jobListProfessionalReducer from "./Professional/JobListSlice";
import savePromotionReducer from "./Professional/SavePromotionSlice";
import promotionListProfessionalReducer from "./Professional/PromotionListSlice";
import updatePromotionReducer from "./Professional/UpdatePromotionSlice";
import getBoostBidProfessionalReducer from "./Professional/GetBoostBidsSlice";
import submitBidProfessionalReducer from "./Professional/SubmitBidSlice";
import setBookMarkJobByProfessionalReducer from "./Professional/UpdateJobFavSlice";
import updateProfileClientReducer from "./Client/UpdateProfileClientSlice";
//import logoutProfessionalReducer from "./Professional/LogoutProfessionalSlice";
import logoutClientReducer from "./Client/LogoutClientSlice";
import deleteAccountClientReducer from "./Client/DeleteAccountClientSlice";
import updatePasswordClientReducer from "./Client/UpdatePasswordClientSlice";
import getSettingsReducer from "./Common/GetSettingsSlice";

import deleteAccountProfessionalReducer from "./Professional/DeleteAccountProfessionalSlice";
import logoutProfessionalReducer from "./Professional/LogoutProfessionalSlice";
import updatePasswordProfessionalReducer from "./Professional/UpdatePasswordProfessionalSlice";
import getBidListProfessionalReducer from "./Professional/BidListingProfessionalSlice";
import updateBidProfessionalReducer from "./Professional/BidUpdateProfessionalSlice";

import getBidDetailsProfessionalReducer from "./Professional/BidDetailsProfessionalSlice";

import getChatHistoryProfessionalReducer from "./Professional/ChatListProfessionalSlice";
import getChatDetailsProfessionalReducer from "./Professional/ChatDetailsProfessionalSlice";

import getJobDetailsWithBidProfessionalReducer from "./Professional/JobDetailsWithBidSlice";
import getBlogReducer from "./Common/BlogSlice";
import getBlogDetailReducer from "./Common/BlogDetailSlice";

import getChatDetailsClientReducer from "./Client/ChatDetailsClientSlice";
import getChatHistoryClientReducer from "./Client/ChatListClientSlice";

import savePaymentRequestJobReducer from "./Professional/SavePaymentRequestJobSlice";

import getJobPaymentRequestsClientReducer from "./Client/GetJobPaymentRequestsSlice";
import getJobPaymentHistoryClientReducer from "./Client/GetJobPaymentHistorySlice";

import updateJobPaymentClientReducer from "./Client/UpdateJobPaymentSlice";
import getSubscriptionProfessionalReducer from "./Professional/GetSubscriptionProfessionalSlice";
import updateSubscriptionProfessionalReducer from "./Professional/UpdateSubscriptionProfessionalSlice";

import getCreditHistoryProfessionalReducer from "./Professional/GetCreditHistoryProfessionalSlice";
import getCreditHistoryClientReducer from "./Client/GetCreditHistoryClientSlice";

import getJobPaymentHistoryProfessionalReducer from "./Professional/GetJobPaymentHistoryProfessionalSlice";
import promotionDetailsProfessionalReducer from "./Professional/PromotionDetailsProfessionalSlice";


import getNotificationProfessionalReducer from "./Professional/GetNotificationProfessionalSlice";
import getNotificationClientReducer from "./Client/GetNotificationsClientSlice";

import getAllNotificationsProfessionalReducer from "./Professional/GetAllNotificationsProfessionalSlice";

import contactUsReducer from "./Common/ContactUsSlice";

import forgotPasswordReducer from "./Common/ForgotPasswordSlice";

import verifyForgotPasswordReducer from "./Common/VerifyForgotPasswordCodeSlice";
import updatePasswordForgotReducer from "./Common/UpdatePasswordForgotSlice";

import  getServiceAreaProfessionalReducer from "./Professional/GetServiceAreasListProSlice";
import checkStatusForServiceAreaSubAfterTryAgainReducer from "./Professional/CheckStatusForServiceAreaSubAfterTryAgainSlice";
import setJobScheduleReducer from "./Professional/SetJobScheduleSlice";

const store = configureStore({
  reducer: {
    emailVerificationCodeReducer: emailVerificationCodeReducer,
    emailVerifyCodeReducer: emailVerifyCodeReducer,
    createProfileProfessionalReducer: createProfileProfessionalReducer,
    getProfileProfessionalReducer: getProfileProfessionalReducer,
    getServiceProfessionalReducer: getServiceProfessionalReducer,
    loginProfessionalReducer: loginProfessionalReducer,
    loginClientReducer: loginClientReducer,
    signUpClientReducer: signUpClientReducer,
    signUpProfessionalReducer: signUpProfessionalReducer,
    emailVerificationV2ProfessionalReducer: emailVerificationV2ProfessionalReducer,
    createProfileClientReducer: createProfileClientReducer,
    emailVerificationV2Reducer: emailVerificationV2Reducer,
    getProfileClientReducer: getProfileClientReducer,
    verifyLoginPhoneClientReducer: verifyLoginPhoneClientReducer,
    uploadMediaReducer: uploadMediaReducer,
    updateProfileProfessionalReducer: updateProfileProfessionalReducer,
    jobListProfessionalReducer: jobListProfessionalReducer,
    savePromotionReducer: savePromotionReducer,
    promotionListProfessionalReducer: promotionListProfessionalReducer,
    updatePromotionReducer: updatePromotionReducer,
    getBoostBidProfessionalReducer: getBoostBidProfessionalReducer,
    submitBidProfessionalReducer: submitBidProfessionalReducer,
    setBookMarkJobByProfessionalReducer: setBookMarkJobByProfessionalReducer,
    updateProfileClientReducer: updateProfileClientReducer,
    logoutClientReducer: logoutClientReducer,
    deleteAccountClientReducer: deleteAccountClientReducer,
    updatePasswordClientReducer: updatePasswordClientReducer,
    getSettingsReducer: getSettingsReducer,
    deleteAccountProfessionalReducer: deleteAccountProfessionalReducer,
    logoutProfessionalReducer: logoutProfessionalReducer,
    updatePasswordProfessionalReducer: updatePasswordProfessionalReducer,
    getBidListProfessionalReducer: getBidListProfessionalReducer,
    updateBidProfessionalReducer: updateBidProfessionalReducer,
    getBidDetailsProfessionalReducer: getBidDetailsProfessionalReducer,
    getChatHistoryProfessionalReducer: getChatHistoryProfessionalReducer,
    getChatDetailsProfessionalReducer: getChatDetailsProfessionalReducer,
    getJobDetailsWithBidProfessionalReducer:
      getJobDetailsWithBidProfessionalReducer,
    getBlogReducer: getBlogReducer,
    getBlogDetailReducer: getBlogDetailReducer,
    getChatDetailsClientReducer: getChatDetailsClientReducer,
    getChatHistoryClientReducer: getChatHistoryClientReducer,
    savePaymentRequestJobReducer: savePaymentRequestJobReducer,
    getJobPaymentRequestsClientReducer: getJobPaymentRequestsClientReducer,
    getJobPaymentHistoryClientReducer: getJobPaymentHistoryClientReducer,
    updateJobPaymentClientReducer: updateJobPaymentClientReducer,
    getSubscriptionProfessionalReducer: getSubscriptionProfessionalReducer,
    updateSubscriptionProfessionalReducer:updateSubscriptionProfessionalReducer,
    getCreditHistoryProfessionalReducer: getCreditHistoryProfessionalReducer,
    getCreditHistoryClientReducer: getCreditHistoryClientReducer,
    getJobPaymentHistoryProfessionalReducer: getJobPaymentHistoryProfessionalReducer,
    promotionDetailsProfessionalReducer: promotionDetailsProfessionalReducer,
    getNotificationProfessionalReducer: getNotificationProfessionalReducer,
    getNotificationClientReducer: getNotificationClientReducer,
    getAllNotificationsProfessionalReducer: getAllNotificationsProfessionalReducer,
    contactUsReducer: contactUsReducer,
    forgotPasswordReducer: forgotPasswordReducer,
    verifyForgotPasswordReducer:verifyForgotPasswordReducer,
    updatePasswordForgotReducer:updatePasswordForgotReducer,
    getServiceAreaProfessionalReducer:getServiceAreaProfessionalReducer,
    checkStatusForServiceAreaSubAfterTryAgainReducer: checkStatusForServiceAreaSubAfterTryAgainReducer,
    setJobScheduleReducer: setJobScheduleReducer
  },
});

export default store;
